// extracted by mini-css-extract-plugin
export var infoRow = "_u2-2";
export var labelContainer = "_u2-0";
export var rightInfo = "_u2-1";